import { apiClient } from './api';
import type { UserAddress } from '@/types';

export interface CreateAddressDTO {
  title: string;
  city: string;
  district: string;
  fullAddress: string;
  latitude: number;
  longitude: number;
  buildingInfo?: string;
  isDefault?: boolean;
}

export const addressService = {
  /**
   * Get all user addresses
   */
  async getAddresses(): Promise<UserAddress[]> {
    const response = await apiClient.get<UserAddress[]>('/addresses');
    return response.data.data;
  },

  /**
   * Get address by ID
   */
  async getAddress(id: string): Promise<UserAddress> {
    const response = await apiClient.get<UserAddress>(`/addresses/${id}`);
    return response.data.data;
  },

  /**
   * Create new address
   */
  async createAddress(data: CreateAddressDTO): Promise<UserAddress> {
    const response = await apiClient.post<{ data: UserAddress }>('/addresses', data);
    return response.data.data;
  },

  /**
   * Update address
   */
  async updateAddress(id: string, data: Partial<CreateAddressDTO>): Promise<UserAddress> {
    const response = await apiClient.patch<{ data: UserAddress }>(`/addresses/${id}`, data);
    return response.data.data;
  },

  /**
   * Delete address
   */
  async deleteAddress(id: string): Promise<void> {
    await apiClient.delete(`/addresses/${id}`);
  },

  /**
   * Set address as default
   */
  async setDefaultAddress(id: string): Promise<UserAddress> {
    const response = await apiClient.patch<{ data: UserAddress }>(`/addresses/${id}/set-default`);
    return response.data.data;
  },
};
